var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReorderMedicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3C2 1.89543 2.89543 1 4 1H11C12.1046 1 13 1.89543 13 3V5H10V8H12C12.5523 8 13 8.44772 13 9V21C13 21.5523 12.5523 22 12 22H3C2.44771 22 2 21.5523 2 21V9C2 8.44772 2.44772 8 3 8H5V5H2V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2H4C3.44772 2 3 2.44772 3 3V4H4H11H12V3C12 2.44772 11.5523 2 11 2ZM2 5H4V7H3C1.89543 7 1 7.89543 1 9V21C1 22.1046 1.89543 23 3 23H12C13.1046 23 14 22.1046 14 21V9C14 7.89543 13.1046 7 12 7H11V5H13V3C13 1.89543 12.1046 1 11 1H4C2.89543 1 2 1.89543 2 3V5ZM10 7V5H5V7H10ZM4 8H3C2.44772 8 2 8.44772 2 9V21C2 21.5523 2.44772 22 3 22H12C12.5523 22 13 21.5523 13 21V9C13 8.44772 12.5523 8 12 8H11H10H5H4Z",
    fill: "#797979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12H7V15H4V16H7V19H8V16H11V15H8V12Z",
    fill: "#797979"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 6.5,
    fill: "#E57200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18.2492L15.75 19.7374C15.75 19.8428 15.6821 19.938 15.5783 19.9793C15.4748 20.0202 15.3536 19.9996 15.273 19.9257L12.0855 17.0383C12.0307 16.9889 12 16.921 12 16.85C12 16.7789 12.0307 16.711 12.0855 16.6617L15.273 13.7742C15.3544 13.7007 15.4751 13.68 15.5782 13.7206C15.6821 13.7619 15.75 13.8571 15.75 13.9625L15.75 15.45L16.2817 15.45C18.0203 15.45 19.623 14.568 20.4641 13.1498L20.472 13.1365C20.5222 13.0511 20.6175 13 20.7188 13C20.742 13 20.7653 13.0025 20.7885 13.0081C20.913 13.0378 21 13.1424 21 13.2625C21 15.9834 18.6536 18.2023 15.75 18.2492Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorderMedicationIcon);
export default __webpack_public_path__ + "static/media/reorderMedicationIcon.29de396169725e625fa7d92c2e9be6fa.svg";
export { ForwardRef as ReactComponent };